import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import zh_TW from 'ant-design-vue/lib/locale-provider/zh_TW';
import en_US from 'ant-design-vue/lib/locale-provider/en_US';
import es_ES from 'ant-design-vue/lib/locale-provider/es_ES';
import fr_FR from 'ant-design-vue/lib/locale-provider/fr_FR';
import ru_RU from 'ant-design-vue/lib/locale-provider/ru_RU';
import moment from 'moment';
import 'moment/locale/zh-cn';
// import * as rrweb from 'rrweb';
// import {mapState} from 'vuex';
// import {uploadTracback} from '@/api/user';
export default {
  name: 'App',
  data() {
    return {
      locales: {
        zh_CN,
        zh_TW,
        en_US,
        es_ES,
        fr_FR,
        ru_RU
      },
      events: [],
      locale: 'zh_CN'
    };
  },
  async mounted() {
    moment.locale('zh-cn');
    if (sessionStorage.getItem('locale')) {
      this.locale = this.$store.state.setting.locale;
      this.$i18n.locale = this.locale;
      await this.$store.dispatch('setting/getLocaleResource');
      this.$store.commit('setting/CHANGE_LOCALE', sessionStorage.getItem('locale'));
      if (sessionStorage.getItem('locale') != 'zh_CN' && sessionStorage.getItem('locale') != 'zh_TW') {
        moment.locale('en');
      }
    }
    this.setI18nMsg();
    setTimeout(() => {
      var _this$$store;
      clearInterval();
      if ((_this$$store = this.$store) !== null && _this$$store !== void 0 && (_this$$store = _this$$store.state) !== null && _this$$store !== void 0 && (_this$$store = _this$$store.user) !== null && _this$$store !== void 0 && _this$$store.accountInfo) {
        this.$store.dispatch('user/setUploadTrackback');
        let popMessageList = sessionStorage.getItem('popMessageList');
        if (popMessageList && popMessageList.length > 0) {
          popMessageList = JSON.parse(popMessageList);
          this.$store.commit('message/SET_POP_MESSAGE_LIST', popMessageList);
        }
        sessionStorage.removeItem('popMessageList');
        this.$store.dispatch('message/loopPopMessageList', {});
        // this.$store.dispatch('message/getSystemForcePopMessageList', {});
        this.$store.dispatch('message/getUnReadCount');
      }
    }, 500);
  },
  computed: {
    getLocale() {
      return this.$store.state.setting.locale;
    }
  },
  watch: {
    getLocale(val) {
      this.locale = val;
      this.$i18n.locale = this.locale;
      this.setI18nMsg();
      if (val != 'zh_CN' && val != 'zh_TW') {
        moment.locale('en');
      }
      sessionStorage.setItem('changeLocale', true);
    }
  },
  methods: {
    setI18nMsg() {
      let lang = JSON.parse(sessionStorage.getItem('localeResource')) || {
        zh_CN: {},
        zh_TW: {},
        en_US: {},
        fr_FR: {},
        ru_RU: {},
        es_ES: {}
      };
      const newMsg = {
        zh_CN: {
          ...lang.zh_CN
        },
        zh_TW: {
          ...lang.zh_TW
        },
        en_US: {
          ...lang.en_US
        },
        es_ES: {
          ...lang.es_ES
        },
        fr_FR: {
          ...lang.fr_FR
        },
        ru_RU: {
          ...lang.ru_RU
        }
      };
      this.$i18n.setLocaleMessage(this.locale, newMsg[this.locale]);
    }
    // startRecord() {
    //   let that = this;
    //   let loginTime = sessionStorage.getItem('loginTime');
    //   let loginId = sessionStorage.getItem('loginRandomId');
    //   rrweb.record({
    //     emit(event) {
    //       if (this.accountInfo && loginTime) {
    //         that.events.push(event);
    //       }
    //     }
    //   });
    //   let Timer = setInterval(async () => {
    //     if (this.events.length && this.accountInfo && loginTime) {
    //       console.log(this.events);
    //       await this.toRequest(loginId);
    //     } else {
    //       if (!this.accountInfo) {
    //         clearInterval(Timer);
    //         let stopFn = rrweb.record({
    //           emit(event) {
    //             setTimeout(() => {
    //               stopFn();
    //             }, 100);
    //           }
    //         });
    //       }
    //     }
    //   }, 10000);
    // },
    // async toRequest(loginId) {
    //   let loginTime = sessionStorage.getItem('loginTime');
    //   let params = {
    //     loginId,
    //     source_channel: this.accountInfo?.customerId === 0 ? 1 : 2,
    //     type: 1,
    //     startAt: moment(Number(loginTime)).format('YYYY-MM-DD HH:mm:ss'),
    //     source: JSON.stringify(this.events),
    //     userId: this.accountInfo?.id,
    //     customerId: this.accountInfo?.customerId
    //   };
    //   await uploadTracback(params);
    //   this.events = [];
    // }
  }
};